<template>
    <FullCalendar class="calendar-wrapper h-100" :options="calendarOptions"></FullCalendar>
</template>

<style src="./FullCalendar.scss"></style>

<script lang="ts">
import { defineComponent } from "vue";

import { CalendarOptions } from "@fullcalendar/core";
import FullCalendar from "@fullcalendar/vue3";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";

import { isMobileScreenSize } from "../../../utilities/isMobileScreenSize";

export default defineComponent({
    props: {
        updatedOptions: { type: Object }
    },

    components: {
        FullCalendar
    },

    data() {
        return {
            editable: true as boolean,
            isMobile: false as boolean
        };
    },

    mounted() {
        this.isMobile = isMobileScreenSize();
    },

    computed: {
        calendarOptions(): CalendarOptions {
            const slotOptions: CalendarOptions = {
                slotLabelFormat: [{ weekday: "short", month: "short", day: "numeric" }],
                slotDuration: {
                    days: 1
                }
            };

            if (this.isMobile) {
                slotOptions.slotMinWidth = 150;
            }

            return {
                headerToolbar: false,
                plugins: [resourceTimelinePlugin, interactionPlugin],
                schedulerLicenseKey: "0329665787-fcs-1602782908",
                initialView: "resourceTimeline",
                editable: this.editable,
                eventDurationEditable: false,
                eventResize: (event: any) => {
                    event.revert();
                },
                dayMaxEvents: 2,
                dayMaxEventRows: 2,
                resourceAreaWidth: "150px",
                ...slotOptions,
                ...this.updatedOptions
            };
        }
    }
});
</script>
